import { render, staticRenderFns } from "./validationtask-config-activities-modal.vue?vue&type=template&id=f7aeb9c4"
import script from "./validationtask-config-activities-modal.vue?vue&type=script&lang=js"
export * from "./validationtask-config-activities-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports